import { defaultProductionPagination } from '../../constants/consts';

export const GET_COMPANY_DATA = 'app/Company/GET_COMPANY_DATA';
export const GET_COMPANY_UNPUBLISHED_SEASON = 'app/Company/GET_COMPANY_UNPUBLISHED_SEASON';
export const GET_COMPANY_SEASONS_VALUES = 'app/Company/GET_COMPANY_SEASONS_VALUES';
export const GET_COMPANY_VENUES = 'app/Company/GET_COMPANY_VENUES';
export const GET_COMPANY_CONTACT = 'app/Company/GET_COMPANY_CONTACT';
export const ADD_AND_UPDATE_CONTACTS = 'app/Company/ADD_AND_UPDATE_CONTACTS';
export const SET_COMPANY = 'app/Company/SET_COMPANY';
export const UPDATE_COMPANY = 'app/Company/UPDATE_COMPANY';
export const GET_MUSICAL_WORKS_LIST = 'app/Company/GET_MUSICAL_WORKS_LIST';
export const GET_COMPANY_EDIT_SEASON = 'app/Company/GET_COMPANY_EDIT_SEASON';
export const GET_COMPANY_IMAGES = 'app/Company/GET_COMPANY_IMAGES';
export const GET_COMPANY_PRODCUTION_IMAGES = 'app/Company/GET_COMPANY_PRODCUTION_IMAGES';
export const GET_COMPANY_VIDEOS = 'app/Company/GET_COMPANY_VIDEOS';
export const GET_COMPANY_PRODUCTION_VIDEOS = 'app/Company/GET_COMPANY_PRODUCTION_VIDEOS';
export const GET_COMPANY_LS_VOD = 'app/Company/GET_COMPANY_LS_VOD';
export const SET_SEASONS = 'app/Company/SET_SEASONS';
export const CLEAR_EDIT_SEASONS = 'app/Company/CLEAR_EDIT_SEASONS';
export const GET_COMPANY_STAFF = 'app/Company/GET_COMPANY_STAFF';
export const UPDATE_COMPANY_INFO = 'app/Company/UPDATE_COMPANY_INFO';
export const UPDATE_COMPANY_VENUE = 'app/Company/UPDATE_COMPANY_VENUE';
export const GET_COMPANY_DESCRIPTIONS = 'app/Company/GET_COMPANY_DESCRIPTIONS';
export const CREATE_COMPANY_DESCRIPTION = 'app/Company/CREATE_COMPANY_DESCRIPTION';
export const UPDATE_COMPANY_DESCRIPTION = 'app/Company/UPDATE_COMPANY_DESCRIPTION';
export const DELETE_COMPANY_DESCRIPTION = 'app/Company/DELETE_COMPANY_DESCRIPTION';
export const UPDATE_COMPANY_VIDEO = 'app/Company/UPDATE_COMPANY_VIDEO';
export const ADD_COMPANY_VIDEO = 'app/Company/ADD_COMPANY_VIDEO';
export const DELETE_COMPANY_VIDEO = 'app/Company/DELETE_COMPANY_VIDEO';
export const GET_COMPANY_PRODUCTIONS = 'app/Company/GET_COMPANY_PRODUCTIONS';
export const GET_COMPANY_EMPLOYEES = 'app/Company/GET_COMPANY_EMPLOYEES';
export const GET_COMPANY_BANNER_IMAGES = 'app/Company/GET_COMPANY_BANNER_IMAGES';
export const GET_COMPANY_SEARCH_PRODUCTIONS_LIST = 'app/Company/GET_COMPANY_SEARCH_PRODUCTIONS_LIST';
export const GET_COMPANY_TRANSLATIONS = 'app/Company/GET_COMPANY_TRANSLATIONS';
export const UPDATE_COMPANY_TRANSLATIONS = 'app/Company/UPDATE_COMPANY_TRANSLATIONS';
export const DELETE_COMPANY_TRANSLATIONS = 'app/Company/DELETE_COMPANY_TRANSLATIONS';
export const SET_COMPANY_PRODUCTION_RENTAL_ACTION = 'app/Company/SET_COMPANY_PRODUCTION_RENTAL_ACTION';
export const UPDATE_RENTAL_INCLUDES_ACTION = 'app/Company/UPDATE_RENTAL_INCLUDES_ACTION';
export const GET_COMPANY_YOUNG_ARTIST_PROGRAM = 'app/Company/GET_COMPANY_YOUNG_ARTIST_PROGRAM';
export const CREATE_COMPANY_YOUNG_ARTIST_PROGRAM = 'app/Company/CREATE_COMPANY_YOUNG_ARTIST_PROGRAM';
export const DELETE_COMPANY_YOUNG_ARTIST_PROGRAM = 'app/Company/DELETE_COMPANY_YOUNG_ARTIST_PROGRAM';
export const GET_COMPANY_FESTIVAL = 'app/Company/GET_COMPANY_FESTIVAL';
export const CREATE_COMPANY_FESTIVAL = 'app/Company/CREATE_COMPANY_FESTIVAL';
export const DELETE_COMPANY_FESTIVAL = 'app/Company/DELETE_COMPANY_FESTIVAL';
export const GET_ABOUT_COMPANY_VIDEO = 'app/Company/GET_ABOUT_COMPANY_VIDEO';
export const GET_COMPANY_REVIEWS = 'app/Company/GET_COMPANY_REVIEWS';
export const GET_COMPANY_PRODUCTION_REVIEWS = 'app/Company/GET_COMPANY_PRODUCTION_REVIEWS';

export const PRODUCTIONS_TYPES = {
  published: 'published',
  unpublished: 'unpublished',
};

export const defaultCompanyProductionsPagination = defaultProductionPagination;

// edit

export const companyEditTabValues = {
  edit: 'edit',
  seasons: 'seasons',
  prod_rent: 'prod_rent',
};

export const REVIVAL_STATUS_TYPE = {
  PENDING: 'pending',
  FINISHED: 'finished',
  FAILED: 'failed',
};

export const REVIVAL_SEARCH_TYPE = {
  SEASON: 'season',
  ALL: 'all',
};

export const ADD_ACTION_TYPE = {
  ADD: 'add',
  REVIVE: 'revive',
};

export const editCompanyTabValues = {
  seasons: 'seasons',
  rentals: 'rentals',
  videos: 'videos',
  photos: 'photos',
  reviews: 'reviews',
  companyInfo: 'company-info',
  digitalPresence: 'digital-presence',
  staffManagement: 'staff-management',
  contactInfo: 'contact-info',
};
